<template>
  <div class="order-wrapper payment-wrapper">
    <div v-if="indentId ? (!isOrdersDetailsLoading && order) : (depots && depots.length)">
      <DocumentView
        :order="order"
        :deliveryId="deliveryId"
        :depotRefId="depotRefId"
        :depots="depots"
        :parentDelivery="parentDelivery"
        :isDocumentlisting="true"
      >
      </DocumentView>
    </div>
    <div v-else class="status-msg my-md">
      Loading...
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import DocumentView from '@/components/orders/DocumentView';

export default {
  components: {
    DocumentView,
  },
  data() {
    return {
      indentId: null,
      deliveryId: null,
      depotRefId: null,
      parentDelivery: null,
    };
  },
  async created() {
    this.isLoadingData = true;
    this.$store.commit('order/SET_ORDER', {});
    this.indentId = this.$route.query.indentId;
    this.deliveryId = this.$route.query.deliveryId;
    this.depotRefId = this.$route.query.depotRefId;
    this.parentDelivery = this.$route.query.parent;
    try {
      if (this.indentId) {
        const result = await this.$store.dispatch('order/find', this.indentId);
        if (this.$hasFeature('packing_indent')) {
          this.getPackingDetails(this.order.order_number);
        }
      }
    } catch (error) {
      this.$error({ message: 'Unable to load data' });
    }
    this.isLoadingData = false;
  },
  computed: {
    ...mapGetters({
      isOrdersDetailsLoading: 'order/isOrderLoading',
      order: 'order/find',
      depots: 'app/otherDepots',
    }),
  },
  methods: {
    async getPackingDetails(orderId) {
      try {
        if (this.$hasFeature('packing_indent')) {
          const result = await this.$store.dispatch('order/getPackingDetailsSummary', orderId);
          if (!result) {
            this.$errorMessage({ message: this.$t('GENERAL ERROR') });
          } else if (result && result.error) {
            this.$errorMessage({ message: result.error });
          }
        }
      } catch (err) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
